import { createSlice } from "@reduxjs/toolkit";
import productsData from "../../data/mydata.json";

const initialState = {
  items: productsData || [],
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts(state, action) {
      state.items = Array.isArray(action.payload) ? action.payload : [];
    },
  },
});

export const { setProducts } = productsSlice.actions;
export default productsSlice.reducer;

